/* Zeichnet die Marker-Unterstriche, sobald sie in den Viewport kommen.
   Wird von mehreren Sections eingebunden; der Guard verhindert doppelte Observer. */
(function () {
  if (window.__hoellMarkerInit) return;
  window.__hoellMarkerInit = true;

  var SELECTOR = '.hoell-mark';
  var observer = null;

  function drawAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-drawn');
  }

  function observe(root) {
    var marks = (root || document).querySelectorAll(SELECTOR + ':not(.is-drawn)');
    if (!marks.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      drawAll(marks);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            entries[i].target.classList.add('is-drawn');
            observer.unobserve(entries[i].target);
          }
        },
        { threshold: 0.35 }
      );
    }
    for (var j = 0; j < marks.length; j++) observer.observe(marks[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe(document);
    });
  } else {
    observe(document);
  }

  /* Theme-Editor: neu gerenderte Sections nachtraeglich einsammeln */
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
  });
})();
